<template>
  <div>
    <b-card
      v-if="photo"
      no-body
      class="shadow-sm clickable"
      style="width: 270px; height: 270px"
      @click="openModal"
    >
      <b-container fluid class="p-2 d-flex flex-column justify-content-center align-items-center h-100">
        <div class="d-flex justify-content-center align-items-center h-100 w-100">
          <b-card-img
            v-if="photo.img_url"
            :src="photo.img_url"
            top
            style="max-height: 220px; object-fit: contain;"
          />
          <div v-else :class="'preview-anchor-' + photo.id" style="width: 238px;"></div>
        </div>

        <b-card-text class="text-center mt-2 w-100">
          <p class="fs-14 mb-0 font-weight-bold text-truncate">
            {{ photo.caption }}
          </p>
        </b-card-text>
      </b-container>
    </b-card>

    <b-modal
      v-model="modalShow"
      size="lg"
      :title="modalTitle"
      static
      hide-footer
    >
      <b-container v-if="photo">
        <b-row align-h="center">
          <b-img v-if="photo.img_url_lg" :src="photo.img_url_lg" class="modal-img" />
          <div v-else :class="'preview-anchor-' + photo.id" />
        </b-row>
        <b-row v-if="captionFormShow" align-h="center">
          <b-col>
            <b-form-group>
              <b-textarea
                v-model="form.caption"
                rows="3"
                placeholder="Escribir leyenda"
                autofocus
                @keyup.enter="updatePhoto"
              ></b-textarea>
            </b-form-group>
          </b-col>
        </b-row>
        <b-row v-else-if="!captionFormShow && editable" class="mt-3">
          <b-col>
            <p>{{ photo.caption }}</p>
          </b-col>
        </b-row>
        <b-row v-if="actionable" align-h="between">
          <Button variant="red" @click="promptDelete">
            Borrar
          </Button>
          <div v-if="editable">
            <Button v-if="captionFormShow" variant="green" @click="updatePhoto">
              Guardar
            </Button>
            <Button v-else @click="captionFormShow = !captionFormShow">
              Editar Leyenda
            </Button>
          </div>
        </b-row>
      </b-container>
    </b-modal>

    <b-modal
      v-model="confirmDeleteShow"
      centered
      hide-header
      hide-footer
      body-class="p-0"
      content-class="border-0 bg-transparent"
    >
      <div class="bg-white text-center shadow-lg" style="border-radius: 24px; overflow: hidden;">
        <div class="d-flex justify-content-end px-3 pt-3">
          <button type="button" class="close" aria-label="Cerrar" style="font-size: 28px;" @click="confirmDeleteShow = false">&times;</button>
        </div>
        <div class="px-4 pb-4">
          <div class="rounded-circle d-flex align-items-center justify-content-center mx-auto mb-3" style="width: 88px; height: 88px; background-color: #fef2f2;">
            <font-awesome-icon :icon="['fas', 'exclamation-triangle']" size="2x" class="text-danger" fixed-width />
          </div>
          <h5 class="font-weight-bold text-dark mb-2">¿Eliminar foto?</h5>
          <p class="text-secondary mb-4">
            La foto será eliminada completamente. La acción no se puede deshacer
          </p>
          <div class="d-flex justify-content-center">
            <button type="button" class="btn btn-secondary rounded-lg font-weight-bold px-4 mx-2" @click="confirmDeleteShow = false">
              Cancelar
            </button>
            <button type="button" class="btn btn-danger rounded-lg font-weight-bold px-4 mx-2" @click="confirmDelete">
              Sí, borrar
            </button>
          </div>
        </div>
      </div>
    </b-modal>
  </div>
</template>

<script>
import Button from './Button'

export default {
  name: 'PhotoCard',
  components: { Button },
  props: {
    photo: {
      type: Object
    },
    editable: {
      type: Boolean,
      required: false,
      default: true
    },
    modalTitle: {
      type: String,
      required: false,
      default: 'Detalles de foto'
    },
    actionable: {
      type: Boolean,
      required: false,
      default: true
    }
  },
  data () {
    return {
      modalShow: false,
      captionFormShow: false,
      confirmDeleteShow: false,
      form: {
        caption: ''
      }
    }
  },
  methods: {
    openModal () {
      this.form.caption = this.photo.caption
      this.modalShow = true
    },
    updatePhoto () {
      this.$emit('photo-updated', { photo: this.photo, form: this.form })
      this.captionFormShow = false
      this.modalShow = false
    },
    promptDelete () {
      this.modalShow = false
      this.confirmDeleteShow = true
    },
    confirmDelete () {
      this.confirmDeleteShow = false
      this.$emit('photo-deleted', this.photo)
    },
    resetModal () {
      this.form.caption = ''
      this.captionFormShow = false
    }
  }
}
</script>

<style scoped>
.photo-card {
  aspect-ratio: 1 / 1;
  width: 100%;
}
.b-card-img {
  object-fit: cover;
  width: 100%;
  height: 100%;
}
</style>